/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./attachmentsItem.vue?vue&type=template&id=6e3c5be0&scoped=true&"
import script from "./attachmentsItem.vue?vue&type=script&lang=js&"
export * from "./attachmentsItem.vue?vue&type=script&lang=js&"
import style0 from "./attachmentsItem.vue?vue&type=style&index=0&id=6e3c5be0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c5be0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
